export const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://api.estima.nutricaoapp.com.br'
  : 'http://localhost:5001';